import api, { prepareQueryParameters } from "@/store/api";
import {AssetDetail} from "@/types";
import {downloadPDF, getFileFromHex} from "@/store/helpers";
import account from "@/store/modules/account";

const emptyState = () => {
    return {
        item: null,
        items: [],
        data: [],
        loading: false,
    }
}

export default {
    namespaced: true,
    state: emptyState(),
    getters: {},
    actions: {
        list(store: any) {
            store.commit('setLoading', true);
            api.get('contracts/list').then(({data}) => {
                store.commit('setItems', data.result);
                store.commit('setLoading', false);
            }).catch(() => {
                store.commit('setItems', []);
                store.commit('setLoading', false);
            })
        },
        download(store: any, params: any) {
            if (account.state.tempUser.token) {
                params.clientToken = account.state.tempUser.token;
            }
            return new Promise((resolve, reject) => {
                api.post('contracts/download', params).then((response) => {
                    downloadPDF(response.data.result.file, response.data.result.name);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
    },
    mutations: {
        setItems(state: any, data: any) {
            state.items = data;
        },
        setLoading(state: any, loading: boolean = false) {
            state.loading = loading;
        }
    }
};
